module.exports = __webpack_public_path__ + "img/noaction.50f8983f.png";